const PRODUCTION_HTTP_URL = 'https://test-server-west.convertros.com';
const PRODUCTION_WS_URL = 'wss://test-server-west.convertros.com';
const LOCAL_HTTP_URL = 'https://localhost:8443';
const LOCAL_WS_URL = 'wss://localhost:8443';

function isLocalHost(hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
}

export function resolveServerUrls({
  env = import.meta.env,
  locationLike = typeof window !== 'undefined' ? window.location : null
} = {}) {
  const local = isLocalHost(locationLike?.hostname);
  return {
    serverHttpUrl: env.VITE_SERVER_HTTP_URL || (local ? LOCAL_HTTP_URL : PRODUCTION_HTTP_URL),
    serverWsUrl: env.VITE_SERVER_WS_URL || (local ? LOCAL_WS_URL : PRODUCTION_WS_URL)
  };
}
